import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { EMPTY_TEXT, Magnetic } from '@mitchell/react.component.ux';
export const StyledTileListWrapper = styled(Grid, {
    shouldForwardProp: prop => isPropValid(prop) && !['isSelectModeOn', 'tilesGap'].includes(prop)
}) `
	width: 100%;
	padding: ${Magnetic.spacer20} ${Magnetic.spacer12};
	${(props) => `background-color: ${props.isSelectModeOn ? Magnetic.backgroundNeutral03 : Magnetic.colorWhite};`}

	${(props) => props.isSelectModeOn ? `transition: background-color 1s linear` : EMPTY_TEXT};

	${(props) => props.tilesGap
    ? `
				display: flex;
  				flex-wrap: wrap;
				gap: ${props.tilesGap};
		`
    : EMPTY_TEXT}
`;
//# sourceMappingURL=AlbumGroup.style.js.map